import { memo } from 'react'
import { Stack, Heading, Flex } from '@chakra-ui/react'

import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'
import Device from './components/Device'
import TakePicture from './components/TakePicture'

function WaysToUpload() {
  const { texts } = useUploadImage()

  return (
    <Stack mb={4}>
      <Heading size="md">{texts?.newImageTitle || 'Nova foto'}</Heading>

      <Flex gap={4}>
        <Device />
        <TakePicture />
      </Flex>
    </Stack>
  )
}

export default memo(WaysToUpload)
